<template>
  <div>
    <div v-if="type === 'file'" class="form-group">
      <div v-if="valueCopy">
        <div class="row">
          <div class="col-1">
            <label v-if="label" class="control-label">
              {{ label }}
            </label>
          </div>
          <div class="col">
            <img :src="valueCopy" alt=" New Icon" class="dashboard-element__icon" />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <input id="file-upload-alt" type="file" @change="onFileSelected($event)" />
          </div>
        </div>
      </div>
      <div v-else>
        <label v-if="label" class="control-label">
          {{ label }}
          <input id="file-upload" type="file" class="form-control" @change="onFileSelected($event)" />
        </label>
      </div>
    </div>
    <div v-if="type === 'radio'" class="form__radio-group">
      <input type="radio" class="form__radio-input" id="radio" />
      <label
        for="radio"
        class="form__radio-label"
        :class="{ 'form__radio-button--checked': checked }"
        @click="clicked()"
      >
        <span class="form__radio-button"></span>
        {{ label }}
      </label>
    </div>
    <div
      v-if="
        type === 'text' ||
        type === 'password' ||
        type === 'email' ||
        type === 'number' ||
        type === 'date' ||
        type === 'url'
      "
      class="form-group"
      :class="{ 'input-group': hasIcon }"
    >
      <slot name="label">
        <label v-if="label" class="control-label">
          {{ label }}
        </label>
      </slot>
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <i :class="addonLeftIcon" class="input-group-text"></i>
        </span>
      </slot>
      <input
        :value="value"
        @input="$emit('input', $event.target.value)"
        :type="type"
        v-bind="$attrs"
        class="form-control"
        aria-describedby="addon-right addon-left"
      />
      <slot></slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <i :class="addonRightIcon" class="input-group-text"></i>
        </span>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    label: String,
    value: [String, Number, Object, File],
    addonRightIcon: String,
    addonLeftIcon: String,
    type: String,
    selected: {
      type: Boolean,
    },
    errorByLoading: false,
  },
  data() {
    return {
      checked: true,
      valueCopy: null,
    };
  },
  computed: {
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
  },
  mounted() {
    this.setValue();
    this.checked = this.setChecked();
  },
  methods: {
    clicked() {
      this.checked = !this.checked;
      this.$emit('checked', this.checked);
    },
    setChecked() {
      return this.selected === '1' || this.selected === true || this.selected === 'true' || this.selected === 1;
    },
    onFileSelected(event) {
      this.valueCopy = event.target.result;
      this.$emit('fileAttached', event.target.files[0]);
    },
    setValue() {
      this.valueCopy = this.value;
    },
  },
};
</script>
<style>
.form-group--error input,
.form-group--error textarea {
  border-color: #f04124 !important;
}
.form-group--error .control-label {
  color: #f04124;
}

.form-group--error {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
